export const SecondaryButton = (props) => {
    const {
        children,
        onClick,
        disabled,
        className,
        outlined = false,
        type = 'button',
    } = props;

    const getButtonClasses = () => {
        if (!outlined) {
            return `bg-primary text-white [border-color:#36A9E1] md:hover:bg-transparent md:hover:text-primary md:hover:[border-color:#36A9E1]`
        } else {
            return `bg-transparent text-primary [border-color:#9ca3af] md:hover:bg-primary md:hover:text-white md:hover:[border-color:#36A9E1]`
        }
    }

    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`rounded-md w-full border border-solid cursor-pointer px-4 py-2 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out ${getButtonClasses()} ${className ?? ''}`}
        >
            {children}
        </button>
    )
}
